





















































































































import Loader from '@/components/common/Loader.vue';
import { Component, Vue } from 'vue-property-decorator';
import { registrationService } from '@/services/RegistrationService';
import { tokenService } from '@/services/TokenService';

@Component({
  components: { Loader },
})
export default class Invitation extends Vue {
  isError = false;
  invitationErrorMsg: any = '';
  isUserRegisterationRequired = false;
  canAcceptInvitation = false;
  workspaceData = {
    id: 0,
    name: '',
  };

  name = '';
  email = '';
  password = '';
  passwordRepeat = '';
  acceptTerms = false;
  isRegistered = false;
  errors: any = [];
  userEmail = '';
  isLogoutShown = false;
  isLoading = false;
  isActiveNameValidation = false;
  isActiveEmailValidation = false;
  emailAddressAlreadyInUse = false;
  emailBlacklisted = false;
  isActivePasswordValidation = false;
  isActivePasswordRepeatValidation = false;
  isActiveTermsValidation = false;

  isWeakPassword() {
    let strength = 0;
    if (/[a-z]+/.test(this.password)) {
      strength += 1;
    }
    if (/[A-Z]+/.test(this.password)) {
      strength += 1;
    }
    if (/[!@#$%^&*(){}.,_=+\-<>;:]/.test(this.password)) {
      strength += 1;
    }
    if (/[0-9]+/.test(this.password)) {
      strength += 1;
    }
    return strength < 3 && this.password;
  }

  register() {
    this.isActiveNameValidation = true;
    this.isActiveEmailValidation = true;
    this.isActivePasswordValidation = true;
    this.isActivePasswordRepeatValidation = true;
    this.isActiveTermsValidation = true;
    this.emailAddressAlreadyInUse = false;
    this.emailBlacklisted = false;

    if (this.acceptTerms === false) {
      return;
    }
    if (this.isLoading) {
      return;
    }
    this.isLoading = true;
    registrationService
      .createAccount(this.name, this.userEmail, this.password)
      .then(() => {
        this.isLoading = false;
        this.isRegistered = true;
      })
      .catch((data: any) => {
        this.isLoading = false;
        if (data.status === 422) {
          if (data.data && data.data.error && data.data.error.email) {
            this.errors.push(this.$t('scripts.emailIsAlreadyInUse'));
          }
        }
      });
  }

  acceptInvitation() {
    registrationService
      .acceptInvitation(this.$route.params.token)
      .then(() => {
        this.$router.push(`/workspaces/${this.workspaceData.id}`).catch(() => {});
      })
      .catch(() => {
        this.isError = true;
        this.invitationErrorMsg = this.$t('scripts.emailIsAlreadyInUse');
      });
  }

  logout() {
    tokenService.removeToken();
    this.$router
      .push({
        path: '/login',
        query: { redirect: this.$route.fullPath },
      })
      .catch(() => {});
  }

  resendActivationEmail() {
    registrationService
      .resendActivationEmail(this.email)
      .then(() => {})
      .catch(() => {});
  }

  mounted() {
    registrationService
      .getInvitation(this.$route.params.token)
      .then((data: any) => {
        if (data) {
          this.workspaceData = data.workspace;
          if (data.has_account) {
            const isAuth = !!tokenService.getToken();
            if (isAuth) {
              const authData = tokenService.getTokenPayload();
              if (authData.email !== data.email) {
                this.isError = true;
                this.invitationErrorMsg = this.$t('scripts.emailIsAlreadyInUse');
                this.isLogoutShown = true;
              } else {
                this.canAcceptInvitation = true;
              }
            } else {
              this.$router
                .push({
                  path: '/login',
                  query: { redirect: this.$route.fullPath },
                })
                .catch(() => {});
            }
          } else {
            this.isUserRegisterationRequired = true;
            this.email = data.email;
            this.userEmail = data.email;
          }
        } else {
          this.isError = true;
        }
      })
      .catch(() => {
        this.isError = true;
        this.invitationErrorMsg = this.$t('users.invalidInvitationToken');
      });
  }
}
